import React from 'react';
import { getOfficialSourcesAdmin, deleteOfficialSource } from '../../../api/contentAdminApi';
import CmsAdminList from './CmsAdminList';

export default function OfficialSourcesAdminList() {
	return (
		<CmsAdminList
			title="Official Sources"
			description="Government and authority URLs with verification dates."
			addHref="/admin/cms/official_source_form"
			formPath="/admin/cms/official_source_form"
			resourceKey="official_sources"
			fetchList={getOfficialSourcesAdmin}
			deleteItem={deleteOfficialSource}
			getRowTitle={(row) => row.name}
			getRowSubtitle={(row) => row.source_type}
		/>
	);
}
